var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-line-img-box"},[_c('img',{attrs:{"src":require('@/assets/images/TimeLineImg/'+ Number(_vm.LineNumber) + '.jpg'),"alt":"蚂蚁写作"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }